import axios from '@/plugins/axios';
import { Profile } from './profile.model';
import BaseService from '../base-service';

export default class ProfilesService extends BaseService<Profile> {
  get endpoint() {
    return 'profiles';
  }
}
